import React from 'react'
import { Image } from 'antd';
import Img1 from "./qiaomu1.jpg"
import Img2 from "./qiaomu2.jpg"
import Img3 from "./qiaomu3.jpg"
import Img4 from "./qiaomu4.jpg"
import Img5 from "./qiaomu5.jpg"
import Img6 from "./qiaomu6.jpg"
import Img7 from "./qiaomu7.jpg"
import Img8 from "./qiaomu8.jpg"
import Img9 from "./qiaomu9.jpg"
import Img10 from "./qiaomu10.jpg"
import Img11 from "./qiaomu11.jpg"
import Img12 from "./qiaomu12.jpg"

const width = 1280;

export default function Qiaomu() {
  return (
    <Image.PreviewGroup>
    <Image width={width} src={Img1} />
    <Image width={width} src={Img2} />
    <Image width={width} src={Img3} />
    <Image width={width} src={Img4} />
    <Image width={width} src={Img5} />
    <Image width={width} src={Img6} />
    <Image width={width} src={Img7} />
    <Image width={width} src={Img8} />
    <Image width={width} src={Img9} />
    <Image width={width} src={Img10} />
    <Image width={width} src={Img11} />
    <Image width={width} src={Img12} />
    </Image.PreviewGroup>
  )
}